export function makeHubspotDealLink(id: string | number) {
  if (!id) {
    return '#';
  }
  return `https://app.hubspot.com/contacts/4334705/record/0-3/${id}`;
}

export default makeHubspotDealLink;
